export const BEASTIE_STUFF_RECENTLY_UPDATED: string[] = [
  "shroom_b",
  "moth1",
  "moth2",
  "moth",
  "possum1",
  "possum2",
  "possum",
  "platypus1",
  "platypus2",
  "daredevil1",
  "daredevil",
  "disruptor",
  "ghost1",
  "ghost2",
  "ghost",
  "mantis",
  "monkey",
  "turtle1",
  "turtle2",
  "seabird1",
  "seabird",
  "rainbow",
  "horseshoe",
  "wizard",
  "rat",
  "magpie1",
  "magpie",
  "ibis",
  "gremlin",
  "opossum",
  "olm1",
  "olm",
  "spirit",
  "yeti",
  "platypus",
  "rainbowmon",
  "magpiemon",
];

export const BEASITE_SPRITES_RECENTLY_UPDATED: string[] = [
  "shroom_b",
  "shroom_m",
  "cassowary2",
  "cassowary",
  "frog",
  "bilby2",
  "bilby",
  "kangaroo1",
  "serval1",
  "daredevil1",
  "daredevil",
  "cheerleader",
  "mantis",
  "fox1",
  "turtle1",
  "turtle",
  "mudskipper",
  "rat",
  "magpie",
  "bat1",
  "gremlin",
  "opossum",
  "olm1",
  "yeti",
  "shroommon",
];
